export default "__VITE_ASSET__CjuMxl1Y__"